import { ExecutionSource, MetadataColumnsType, QueryTemplate, QueryType, ValidationStatus } from '../../../API';

export enum ScheduleType {
  ONE_TIME = 'one-time',
  RECURRING = 'recurring',
}

export interface QueryRecord {
  name: string;
  query: string;
  description?: string;
  queryId?: string;
  executionId?: string;
  validationStatus?: ValidationStatus | null;
  validationLogs?: string | null;
}

export type EditQueryType = 'CUSTOM' | 'STANDARD' | 'SEGMENT';

export interface ValidationLogsViewModel {
  message?: string;
  warnings?: string[];
  errors?: string[];
}

export enum WorkbenchType {
  STANDARD_TEMPLATES = 'standard-templates',
  CUSTOM_QUERY = 'custom-query',
}

export interface SaveQueryDraftInput {
  description?: string;
  executionSource: ExecutionSource;
  executionId?: string;
  name: string;
  queryId?: string;
  query: string;
  queryType: QueryType;
  selectedFilterConfig?: string;
  templateId?: string;
  validationLogs?: string | null;
  validationStatus?: ValidationStatus | null;
}

export interface SegmentFilterCondition {
  colName: string;
  operator: string;
  value: string;
}

export interface SegmentFilterNode {
  operator: string;
  condition?: SegmentFilterCondition;
  group?: SegmentFilterNode[];
}

export interface SegmentSelectedFilterConfig {
  tableName: string;
  conditions: SegmentFilterNode[];
}

export interface DataBaseTableItem {
  datasourceName: string;
  databaseName: string;
  tableName: string;
  columns: MetadataColumnsType[];
}

export interface FilterGroup {
  name: string;
  displayName: string;
  allOptions: { label: string; value: string }[];
  options: { label: string; value: string }[];
  dependent: boolean;
  parentFilterName?: string;
  values: string[] | Record<string, string[]>;
}

export interface StandardTemplateFilter {
  name: string;
  displayName: string;
  values: string[] | Record<string, string[]>;
  __typename?: 'TemplateFilter';
  dependent?: boolean;
  parentFilterName?: string;
}

export type StandardTemplate = Omit<QueryTemplate, 'filters'> & {
  filters?: StandardTemplateFilter[] | null;
};
